import axios from 'axios';
import { API_URL } from '../config';

/**
 * Centralized API utility for making HTTP requests
 * Automatically handles authentication tokens and error handling
 */
const api = axios.create({
  baseURL: `${API_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json'
  },
  // Enable CORS credentials
  withCredentials: true
});

// Request interceptor to add authentication tokens to all requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // Add token to both Authorization and x-auth-token headers for compatibility
      config.headers['Authorization'] = `Bearer ${token}`;
      config.headers['x-auth-token'] = token;
    }
    
    // Log all outgoing requests for debugging
    console.log(`API Request: ${config.method.toUpperCase()} ${config.url}`, {
      headers: config.headers,
      data: config.data
    });
    
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for global error handling
api.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.method.toUpperCase()} ${response.config.url}`);
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response && error.response.status === 401) {
      console.error('Authentication error:', error);
      // Optional: Redirect to login page or clear tokens
      // localStorage.removeItem('token');
      // window.location.href = '/login';
    }
    
    // Log all API errors
    console.error('API Error:', error);
    
    return Promise.reject(error);
  }
);

export default api;
